import { useCheckPermissions } from '../shared';

export const usePermissionAllowed = (
  permissions: PermissionType | PermissionType[]
): boolean => {
  const permissionResults = useCheckPermissions(permissions);

  return permissionResults.some(result => result.allowed);
};
